import { useState, useEffect } from 'react';

const getVisibility = () =>
  typeof document !== 'undefined' ? document.visibilityState : true;

const useDocumentVisibility = () => {
  const [documentVisibility, setDocumentVisibility] = useState(getVisibility());

  useEffect(() => {
    const handleVisibilityChange = () => setDocumentVisibility(getVisibility());

    window.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      window.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return documentVisibility;
};

export default useDocumentVisibility;
